var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function toHeikinAshi(bars) {
    var e_1, _a;
    var out = [];
    try {
        for (var bars_1 = __values(bars), bars_1_1 = bars_1.next(); !bars_1_1.done; bars_1_1 = bars_1.next()) {
            var b = bars_1_1.value;
            var close_1 = (b.open + b.high + b.low + b.close) / 4;
            var open_1 = out.length ? (out[out.length - 1].open + out[out.length - 1].close) / 2 : (b.open + b.close) / 2;
            var high = Math.max(b.high, open_1, close_1);
            var low = Math.min(b.low, open_1, close_1);
            out.push({ time: b.time, open: open_1, high: high, low: low, close: close_1, volume: b.volume });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (bars_1_1 && !bars_1_1.done && (_a = bars_1.return)) _a.call(bars_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
}
export function toRenko(bars, brickSize) {
    var e_2, _a;
    var out = [];
    if (!bars.length)
        return out;
    var price = bars[0].close;
    try {
        for (var bars_2 = __values(bars), bars_2_1 = bars_2.next(); !bars_2_1.done; bars_2_1 = bars_2.next()) {
            var b = bars_2_1.value;
            var diff = b.close - price;
            while (Math.abs(diff) >= brickSize) {
                var dir = diff > 0 ? 1 : -1;
                var open_2 = price;
                price += dir * brickSize;
                out.push({
                    time: b.time,
                    open: open_2,
                    high: Math.max(open_2, price),
                    low: Math.min(open_2, price),
                    close: price,
                });
                diff = b.close - price;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (bars_2_1 && !bars_2_1.done && (_a = bars_2.return)) _a.call(bars_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return out;
}
export function toKagi(bars, reversal) {
    var pts = [];
    if (!bars.length)
        return pts;
    var dir = 0;
    var price = bars[0].close;
    pts.push({ x: 0, y: price });
    for (var i = 1; i < bars.length; i++) {
        var c = bars[i].close;
        if (dir >= 0 && c >= price + reversal) {
            dir = 1;
            price = c;
            pts.push({ x: i, y: price });
        }
        else if (dir <= 0 && c <= price - reversal) {
            dir = -1;
            price = c;
            pts.push({ x: i, y: price });
        }
        else if (dir === 1 && c < price - reversal) {
            dir = -1;
            price = c;
            pts.push({ x: i, y: price });
        }
        else if (dir === -1 && c > price + reversal) {
            dir = 1;
            price = c;
            pts.push({ x: i, y: price });
        }
    }
    return pts;
}
export function toPointAndFigure(bars, boxSize, reversal) {
    var e_3, _a;
    if (reversal === void 0) { reversal = 3; }
    var out = [];
    if (!bars.length)
        return out;
    var col = 0;
    var price = bars[0].close;
    var dir = null;
    try {
        for (var bars_3 = __values(bars), bars_3_1 = bars_3.next(); !bars_3_1.done; bars_3_1 = bars_3.next()) {
            var b = bars_3_1.value;
            if (!dir) {
                dir = b.close >= price ? 'X' : 'O';
                price = b.close;
                continue;
            }
            var move = b.close - price;
            var boxes = Math.floor(Math.abs(move) / boxSize);
            if (boxes >= reversal && ((dir === 'X' && move < 0) || (dir === 'O' && move > 0))) {
                dir = dir === 'X' ? 'O' : 'X';
                col++;
                price = b.close;
                out.push({ time: col, open: price, high: price + boxSize, low: price - boxSize, close: price });
            }
            else if (boxes > 0) {
                price += (move > 0 ? 1 : -1) * boxes * boxSize;
                out.push({ time: col, open: price, high: price + boxSize, low: price - boxSize, close: price });
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (bars_3_1 && !bars_3_1.done && (_a = bars_3.return)) _a.call(bars_3);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return out;
}
export function volumeProfile(bars, bins) {
    var e_4, _a;
    var _b;
    if (bins === void 0) { bins = 20; }
    if (!bars.length)
        return [];
    var lows = bars.map(function (b) { return b.low; });
    var highs = bars.map(function (b) { return b.high; });
    var min = Math.min.apply(Math, __spreadArray([], __read(lows), false));
    var max = Math.max.apply(Math, __spreadArray([], __read(highs), false));
    var step = (max - min) / bins || 1;
    var profile = Array.from({ length: bins }, function (_, i) { return ({
        price: min + (i + 0.5) * step,
        volume: 0,
    }); });
    try {
        for (var bars_4 = __values(bars), bars_4_1 = bars_4.next(); !bars_4_1.done; bars_4_1 = bars_4.next()) {
            var b = bars_4_1.value;
            var vol = (_b = b.volume) !== null && _b !== void 0 ? _b : 1;
            var idx = Math.min(bins - 1, Math.floor((b.close - min) / step));
            profile[idx].volume += vol;
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (bars_4_1 && !bars_4_1.done && (_a = bars_4.return)) _a.call(bars_4);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return profile;
}
export var SAMPLE_OHLC = [
    { time: '1', open: 100, high: 105, low: 98, close: 103, volume: 1200 },
    { time: '2', open: 103, high: 108, low: 101, close: 106, volume: 1500 },
    { time: '3', open: 106, high: 107, low: 99, close: 100, volume: 1800 },
    { time: '4', open: 100, high: 104, low: 97, close: 102, volume: 1100 },
    { time: '5', open: 102, high: 110, low: 101, close: 109, volume: 2000 },
    { time: '6', open: 109, high: 112, low: 105, close: 107, volume: 1600 },
    { time: '7', open: 107, high: 109, low: 103, close: 104, volume: 1300 },
];
